import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, useApi, uid } from "../lib/api";
import { ArtCard, Loading, Page, Empty, WhatsAppButton } from "../components/site/Bits";

import { useSpamProtection } from "../components/site/SpamProtection";

function InterestForm({ t, venue }) {
  const spam = useSpamProtection();
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const [done, setDone] = useState(false);
  const tok = useRef(uid());
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const send = async () => {
    if (busy || !spam.ready) return;
    setBusy(true);
    try { await api.post(`/public/invite/${t}/interest`, { ...f, turnstile_token: spam.token, client_token: tok.current }); setDone(true); } catch (e) { toast.error(errMsg(e)); } finally { spam.reset(); setBusy(false); }
  };
  if (done) return <p className="bg-[#EBF0FF] p-5 font-semibold" data-testid="invite-interest-done">Danke! Wir melden uns persönlich. Das ist noch keine verbindliche Ausstellung – Werke, Zeitraum und Bedingungen stimmen wir gemeinsam ab.</p>;
  const inp = "h-12 w-full border border-[#121212] bg-white px-3";
  return (
    <div className="grid sm:grid-cols-2 gap-3" data-testid="invite-interest-form">
      <input placeholder="Dein Name *" value={f.name} onChange={set("name")} className={inp} data-testid="invite-name" />
      <input placeholder="E-Mail" value={f.email} onChange={set("email")} className={inp} data-testid="invite-email" />
      <input placeholder="Telefon/WhatsApp" value={f.phone} onChange={set("phone")} className={inp} data-testid="invite-phone" />
      <input placeholder={`Nachricht (z. B. Wandfläche in ${venue})`} value={f.message} onChange={set("message")} className={inp} />
      <div className="sm:col-span-2">{spam.widget}</div>
      <button disabled={busy || !spam.ready} onClick={send} className="h-12 px-6 bg-[#0047FF] text-white font-semibold sm:col-span-2 sm:w-max" data-testid="invite-interest-submit">Interesse an einer Ausstellung</button>
    </div>
  );
}

export default function Invite() {
  const { token } = useParams();
  const { data, loading, error } = useApi(`/public/invite/${token}`);
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement("meta"); m.name = "robots"; document.head.appendChild(m); }
    m.content = "noindex, nofollow";
    document.title = "Einladung – Kunst und Fund";
    sessionStorage.setItem("kf_src", "invitation");
    return () => { m.content = "index, follow"; };
  }, []);
  if (loading) return <Loading />;
  if (error) return <Page><Empty testid="invite-not-found">Diese Einladung ist nicht mehr verfügbar. <Link to="/kunst" className="underline">Zu den Werken</Link></Empty></Page>;
  return (
    <div data-testid="invite-page">
      <section className="bg-[#F9D6D2] grain">
        <div className="max-w-[1100px] mx-auto px-4 sm:px-8 py-14">
          <p className="font-mono text-xs uppercase tracking-[0.3em]">Persönliche Einladung · {data.city}</p>
          <h1 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-3" data-testid="invite-title">Kunst für {data.venue_name}.</h1>
          <p className="mt-6 max-w-2xl whitespace-pre-line text-base" data-testid="invite-text">{data.text}</p>
        </div>
      </section>
      <Page>
        <h2 className="text-2xl sm:text-3xl font-black mb-8">Vorgeschlagene Werke</h2>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">{data.artworks.map((a, i) => <ArtCard key={a.id} a={a} i={i} />)}</div>
        {!data.artworks.length && <p className="text-[#6E6B65]">Werke werden gerade zusammengestellt.</p>}
        <section className="mt-16 grid lg:grid-cols-2 gap-10">
          <div><h2 className="text-2xl font-black mb-4">So läuft eine Ausstellung ab</h2><ol className="space-y-3">{data.steps.map((s, i) => <li key={s} className="flex gap-3"><span className="font-display font-black text-2xl text-[#0047FF] w-8">{i + 1}</span><span className="pt-1">{s}</span></li>)}</ol></div>
          <div className="space-y-4"><h2 className="text-2xl font-black">Interesse?</h2><InterestForm t={token} venue={data.venue_name} />
            <div className="flex flex-wrap gap-3"><Link to="/kunst" className="h-12 px-5 inline-flex items-center border-2 border-[#121212] font-semibold" data-testid="invite-more">Andere Werke ansehen</Link><WhatsAppButton area={data.whatsapp_area} text={`Hallo! Wir haben eure Einladung für ${data.venue_name} gesehen.`} testid="invite-whatsapp" /></div></div>
        </section>
      </Page>
    </div>
  );
}

